import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  SEALED_getInstance19i1cdv1u9v1e as SEALED_getInstance,
  STRING_getInstance7xungxdjbzv as STRING_getInstance,
  ENUM_getInstance25239ht7oag6o as ENUM_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  JsonArray2urf8ey7u44sd as JsonArray,
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonPrimitive3ttzjh2ft5dnx as JsonPrimitive,
  JsonElementf07o4p6p57al as JsonElement,
  JsonLiteral1u57id0qmqut7 as JsonLiteral,
  JsonNull_getInstance1i1hv1sbjynto as JsonNull_getInstance,
  JsonNull2liwjj96vm0w2 as JsonNull,
} from './JsonElement.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  minify1kh64osmcox7j as minify,
  access$formatDecodingException$tJsonExceptionsKt2yfifxvnjk03f as access$formatDecodingException$tJsonExceptionsKt,
  decodingExceptionOf183k4uqzusb49 as decodingExceptionOf,
} from './internal/JsonExceptions.mjs';
import { JsonDecodingExceptionoyag1psadwuw as JsonDecodingException } from './JsonExceptions.mjs';
import { toLongOrNullutqivezb0wx1 as toLongOrNull } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import { toULongOrNullojoyxi0i9tgj as toULongOrNull } from '../../../../kotlin-kotlin-stdlib/kotlin/text/UStrings.mjs';
import {
  ULong3f9k7s38t3rfp as ULong,
  Companion_getInstance11ies3wlxhmd7 as Companion_getInstance,
  _ULong___get_data__impl__fggpzbbo8lz7f8fnfy as _ULong___get_data__impl__fggpzb,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import {
  serializer2lw83vwvpnyms as serializer,
  serializer1x79l67jvwntn as serializer_0,
  MapSerializer11kmegt3g5c1g as MapSerializer,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toDoubleOrNullkxwozihadygj as toDoubleOrNull } from '../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { toBooleanStrictOrNull2j0md398tkvbj as toBooleanStrictOrNull } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { StringCompanionObject_instance2dx16b5pp3v3z as StringCompanionObject_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import {
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptor.mjs';
import { JsonDecoder1rijst5ne6qla as JsonDecoder } from './JsonDecoder.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { JsonEncoder1qlse6simkfi1 as JsonEncoder } from './JsonEncoder.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
  $this$buildSerialDescriptor.element$default_ey7ac9_k$('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
  $this$buildSerialDescriptor.element$default_ey7ac9_k$('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
  $this$buildSerialDescriptor.element$default_ey7ac9_k$('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
  $this$buildSerialDescriptor.element$default_ey7ac9_k$('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
  $this$buildSerialDescriptor.element$default_ey7ac9_k$('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
  return Unit_instance;
}
function JsonElementSerializer$descriptor$lambda$lambda() {
  return JsonPrimitiveSerializer_getInstance().descriptor_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_0() {
  return JsonNullSerializer_getInstance().descriptor_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_1() {
  return JsonLiteralSerializer_getInstance().descriptor_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_2() {
  return JsonObjectSerializer_getInstance().descriptor_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_3() {
  return JsonArraySerializer_getInstance().descriptor_1;
}
var JsonElementSerializerClass;
function JsonElementSerializer() {
  if (JsonElementSerializerClass === VOID) {
    class $ {
      constructor() {
        JsonElementSerializer_instance = this;
        var tmp = this;
        var tmp_0 = SEALED_getInstance();
        tmp.descriptor_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_pk22vx_k$(encoder, value) {
        verify(encoder);
        if (value instanceof JsonPrimitive()) {
          encoder.encodeSerializableValue_3uuzip_k$(JsonPrimitiveSerializer_getInstance(), value);
        } else {
          if (value instanceof JsonObject()) {
            encoder.encodeSerializableValue_3uuzip_k$(JsonObjectSerializer_getInstance(), value);
          } else {
            if (value instanceof JsonArray()) {
              encoder.encodeSerializableValue_3uuzip_k$(JsonArraySerializer_getInstance(), value);
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_pk22vx_k$(encoder, value instanceof JsonElement() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var input = asJsonDecoder(decoder);
        return input.decodeJsonElement_6lz9ye_k$();
      }
    }
    initMetadataForObject($, 'JsonElementSerializer', VOID, VOID, [KSerializer()]);
    JsonElementSerializerClass = $;
  }
  return JsonElementSerializerClass;
}
var JsonElementSerializer_instance;
function JsonElementSerializer_getInstance() {
  if (JsonElementSerializer_instance === VOID)
    new (JsonElementSerializer())();
  return JsonElementSerializer_instance;
}
function defer(deferred) {
  return new (defer$1())(deferred);
}
var JsonPrimitiveSerializerClass;
function JsonPrimitiveSerializer() {
  if (JsonPrimitiveSerializerClass === VOID) {
    class $ {
      constructor() {
        JsonPrimitiveSerializer_instance = this;
        this.descriptor_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_p6n2zb_k$(encoder, value) {
        verify(encoder);
        var tmp;
        if (value instanceof JsonNull()) {
          encoder.encodeSerializableValue_3uuzip_k$(JsonNullSerializer_getInstance(), JsonNull_getInstance());
          tmp = Unit_instance;
        } else {
          var tmp_0 = JsonLiteralSerializer_getInstance();
          encoder.encodeSerializableValue_3uuzip_k$(tmp_0, value instanceof JsonLiteral() ? value : THROW_CCE());
          tmp = Unit_instance;
        }
        return tmp;
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_p6n2zb_k$(encoder, value instanceof JsonPrimitive() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var jsonDecoder = asJsonDecoder(decoder);
        var result = jsonDecoder.decodeJsonElement_6lz9ye_k$();
        if (!(result instanceof JsonPrimitive())) {
          // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
          var shortMessage = 'Unexpected JSON element, expected JsonPrimitive, had ' + toString(getKClassFromExpression(result));
          var tmp;
          if (jsonDecoder.get_json_woos35_k$().configuration_1.exceptionsWithDebugInfo_1) {
            var tmp$ret$3 = toString(result);
            tmp = toString(minify(tmp$ret$3));
          } else {
            tmp = null;
          }
          var inputValue = tmp;
          throw JsonDecodingException().new_kotlinx_serialization_json_JsonDecodingException_2f7233_k$(access$formatDecodingException$tJsonExceptionsKt(-1, shortMessage, null, null, inputValue), shortMessage, -1, null, inputValue, null);
        }
        return result;
      }
    }
    initMetadataForObject($, 'JsonPrimitiveSerializer', VOID, VOID, [KSerializer()]);
    JsonPrimitiveSerializerClass = $;
  }
  return JsonPrimitiveSerializerClass;
}
var JsonPrimitiveSerializer_instance;
function JsonPrimitiveSerializer_getInstance() {
  if (JsonPrimitiveSerializer_instance === VOID)
    new (JsonPrimitiveSerializer())();
  return JsonPrimitiveSerializer_instance;
}
var JsonNullSerializerClass;
function JsonNullSerializer() {
  if (JsonNullSerializerClass === VOID) {
    class $ {
      constructor() {
        JsonNullSerializer_instance = this;
        this.descriptor_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_52d5kl_k$(encoder, value) {
        verify(encoder);
        encoder.encodeNull_ejiosz_k$();
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_52d5kl_k$(encoder, value instanceof JsonNull() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        verify_0(decoder);
        if (decoder.decodeNotNullMark_us4ba1_k$()) {
          throw decodingExceptionOf("Expected 'null' literal");
        }
        decoder.decodeNull_jzrmuj_k$();
        return JsonNull_getInstance();
      }
    }
    initMetadataForObject($, 'JsonNullSerializer', VOID, VOID, [KSerializer()]);
    JsonNullSerializerClass = $;
  }
  return JsonNullSerializerClass;
}
var JsonNullSerializer_instance;
function JsonNullSerializer_getInstance() {
  if (JsonNullSerializer_instance === VOID)
    new (JsonNullSerializer())();
  return JsonNullSerializer_instance;
}
var JsonLiteralSerializerClass;
function JsonLiteralSerializer() {
  if (JsonLiteralSerializerClass === VOID) {
    class $ {
      constructor() {
        JsonLiteralSerializer_instance = this;
        this.descriptor_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_1mrbye_k$(encoder, value) {
        verify(encoder);
        if (value.isString_1) {
          return encoder.encodeString_424b5v_k$(value.content_1);
        }
        if (!(value.coerceToInlineType_1 == null)) {
          return encoder.encodeInline_wxp5pu_k$(value.coerceToInlineType_1).encodeString_424b5v_k$(value.content_1);
        }
        var tmp0_safe_receiver = toLongOrNull(value.content_1);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return encoder.encodeLong_vlw3uq_k$(tmp0_safe_receiver);
        }
        var tmp1_safe_receiver = toULongOrNull(value.content_1);
        var tmp = tmp1_safe_receiver;
        if ((tmp == null ? null : new (ULong())(tmp)) == null)
          null;
        else {
          var tmp_0 = tmp1_safe_receiver;
          // Inline function 'kotlin.let' call
          var it = (tmp_0 == null ? null : new (ULong())(tmp_0)).data_1;
          var tmp_1 = encoder.encodeInline_wxp5pu_k$(serializer(Companion_getInstance()).get_descriptor_wjt6a0_k$());
          // Inline function 'kotlin.ULong.toLong' call
          var tmp$ret$4 = _ULong___get_data__impl__fggpzb(it);
          tmp_1.encodeLong_vlw3uq_k$(tmp$ret$4);
          return Unit_instance;
        }
        var tmp2_safe_receiver = toDoubleOrNull(value.content_1);
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return encoder.encodeDouble_n270q9_k$(tmp2_safe_receiver);
        }
        var tmp3_safe_receiver = toBooleanStrictOrNull(value.content_1);
        if (tmp3_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return encoder.encodeBoolean_tu2e59_k$(tmp3_safe_receiver);
        }
        encoder.encodeString_424b5v_k$(value.content_1);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_1mrbye_k$(encoder, value instanceof JsonLiteral() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var jsonDecoder = asJsonDecoder(decoder);
        var result = jsonDecoder.decodeJsonElement_6lz9ye_k$();
        if (!(result instanceof JsonLiteral())) {
          // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
          var shortMessage = 'Unexpected JSON element, expected JsonLiteral, had ' + toString(getKClassFromExpression(result));
          var tmp;
          if (jsonDecoder.get_json_woos35_k$().configuration_1.exceptionsWithDebugInfo_1) {
            var tmp$ret$3 = toString(result);
            tmp = toString(minify(tmp$ret$3));
          } else {
            tmp = null;
          }
          var inputValue = tmp;
          throw JsonDecodingException().new_kotlinx_serialization_json_JsonDecodingException_2f7233_k$(access$formatDecodingException$tJsonExceptionsKt(-1, shortMessage, null, null, inputValue), shortMessage, -1, null, inputValue, null);
        }
        return result;
      }
    }
    initMetadataForObject($, 'JsonLiteralSerializer', VOID, VOID, [KSerializer()]);
    JsonLiteralSerializerClass = $;
  }
  return JsonLiteralSerializerClass;
}
var JsonLiteralSerializer_instance;
function JsonLiteralSerializer_getInstance() {
  if (JsonLiteralSerializer_instance === VOID)
    new (JsonLiteralSerializer())();
  return JsonLiteralSerializer_instance;
}
var JsonObjectDescriptorClass;
function JsonObjectDescriptor() {
  if (JsonObjectDescriptorClass === VOID) {
    class $ {
      constructor() {
        JsonObjectDescriptor_instance = this;
        this.$$delegate_0__1 = MapSerializer(serializer_0(StringCompanionObject_instance), JsonElementSerializer_getInstance()).get_descriptor_wjt6a0_k$();
        this.serialName_1 = 'kotlinx.serialization.json.JsonObject';
      }
      get_serialName_u2rqhk_k$() {
        return this.serialName_1;
      }
      getElementName_u4sqmf_k$(index) {
        return this.$$delegate_0__1.getElementName_u4sqmf_k$(index);
      }
      getElementIndex_utfbym_k$(name) {
        return this.$$delegate_0__1.getElementIndex_utfbym_k$(name);
      }
      getElementAnnotations_omrjs6_k$(index) {
        return this.$$delegate_0__1.getElementAnnotations_omrjs6_k$(index);
      }
      getElementDescriptor_ncda77_k$(index) {
        return this.$$delegate_0__1.getElementDescriptor_ncda77_k$(index);
      }
      isElementOptional_heqq56_k$(index) {
        return this.$$delegate_0__1.isElementOptional_heqq56_k$(index);
      }
      get_kind_wop7ml_k$() {
        return this.$$delegate_0__1.get_kind_wop7ml_k$();
      }
      get_isNullable_67sy7o_k$() {
        return this.$$delegate_0__1.get_isNullable_67sy7o_k$();
      }
      get_isInline_usk17w_k$() {
        return this.$$delegate_0__1.get_isInline_usk17w_k$();
      }
      get_elementsCount_288r0x_k$() {
        return this.$$delegate_0__1.get_elementsCount_288r0x_k$();
      }
      get_annotations_20dirp_k$() {
        return this.$$delegate_0__1.get_annotations_20dirp_k$();
      }
    }
    initMetadataForObject($, 'JsonObjectDescriptor', VOID, VOID, [SerialDescriptor()]);
    JsonObjectDescriptorClass = $;
  }
  return JsonObjectDescriptorClass;
}
var JsonObjectDescriptor_instance;
function JsonObjectDescriptor_getInstance() {
  if (JsonObjectDescriptor_instance === VOID)
    new (JsonObjectDescriptor())();
  return JsonObjectDescriptor_instance;
}
var JsonObjectSerializerClass;
function JsonObjectSerializer() {
  if (JsonObjectSerializerClass === VOID) {
    class $ {
      constructor() {
        JsonObjectSerializer_instance = this;
        this.descriptor_1 = JsonObjectDescriptor_getInstance();
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_5nm41s_k$(encoder, value) {
        verify(encoder);
        MapSerializer(serializer_0(StringCompanionObject_instance), JsonElementSerializer_getInstance()).serialize_5ase3y_k$(encoder, value);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_5nm41s_k$(encoder, value instanceof JsonObject() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        verify_0(decoder);
        return new (JsonObject())(MapSerializer(serializer_0(StringCompanionObject_instance), JsonElementSerializer_getInstance()).deserialize_sy6x50_k$(decoder));
      }
    }
    initMetadataForObject($, 'JsonObjectSerializer', VOID, VOID, [KSerializer()]);
    JsonObjectSerializerClass = $;
  }
  return JsonObjectSerializerClass;
}
var JsonObjectSerializer_instance;
function JsonObjectSerializer_getInstance() {
  if (JsonObjectSerializer_instance === VOID)
    new (JsonObjectSerializer())();
  return JsonObjectSerializer_instance;
}
var JsonArrayDescriptorClass;
function JsonArrayDescriptor() {
  if (JsonArrayDescriptorClass === VOID) {
    class $ {
      constructor() {
        JsonArrayDescriptor_instance = this;
        this.$$delegate_0__1 = ListSerializer(JsonElementSerializer_getInstance()).get_descriptor_wjt6a0_k$();
        this.serialName_1 = 'kotlinx.serialization.json.JsonArray';
      }
      get_serialName_u2rqhk_k$() {
        return this.serialName_1;
      }
      getElementName_u4sqmf_k$(index) {
        return this.$$delegate_0__1.getElementName_u4sqmf_k$(index);
      }
      getElementIndex_utfbym_k$(name) {
        return this.$$delegate_0__1.getElementIndex_utfbym_k$(name);
      }
      getElementAnnotations_omrjs6_k$(index) {
        return this.$$delegate_0__1.getElementAnnotations_omrjs6_k$(index);
      }
      getElementDescriptor_ncda77_k$(index) {
        return this.$$delegate_0__1.getElementDescriptor_ncda77_k$(index);
      }
      isElementOptional_heqq56_k$(index) {
        return this.$$delegate_0__1.isElementOptional_heqq56_k$(index);
      }
      get_kind_wop7ml_k$() {
        return this.$$delegate_0__1.get_kind_wop7ml_k$();
      }
      get_isNullable_67sy7o_k$() {
        return this.$$delegate_0__1.get_isNullable_67sy7o_k$();
      }
      get_isInline_usk17w_k$() {
        return this.$$delegate_0__1.get_isInline_usk17w_k$();
      }
      get_elementsCount_288r0x_k$() {
        return this.$$delegate_0__1.get_elementsCount_288r0x_k$();
      }
      get_annotations_20dirp_k$() {
        return this.$$delegate_0__1.get_annotations_20dirp_k$();
      }
    }
    initMetadataForObject($, 'JsonArrayDescriptor', VOID, VOID, [SerialDescriptor()]);
    JsonArrayDescriptorClass = $;
  }
  return JsonArrayDescriptorClass;
}
var JsonArrayDescriptor_instance;
function JsonArrayDescriptor_getInstance() {
  if (JsonArrayDescriptor_instance === VOID)
    new (JsonArrayDescriptor())();
  return JsonArrayDescriptor_instance;
}
var JsonArraySerializerClass;
function JsonArraySerializer() {
  if (JsonArraySerializerClass === VOID) {
    class $ {
      constructor() {
        JsonArraySerializer_instance = this;
        this.descriptor_1 = JsonArrayDescriptor_getInstance();
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_1tf28e_k$(encoder, value) {
        verify(encoder);
        ListSerializer(JsonElementSerializer_getInstance()).serialize_5ase3y_k$(encoder, value);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_1tf28e_k$(encoder, value instanceof JsonArray() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        verify_0(decoder);
        return new (JsonArray())(ListSerializer(JsonElementSerializer_getInstance()).deserialize_sy6x50_k$(decoder));
      }
    }
    initMetadataForObject($, 'JsonArraySerializer', VOID, VOID, [KSerializer()]);
    JsonArraySerializerClass = $;
  }
  return JsonArraySerializerClass;
}
var JsonArraySerializer_instance;
function JsonArraySerializer_getInstance() {
  if (JsonArraySerializer_instance === VOID)
    new (JsonArraySerializer())();
  return JsonArraySerializer_instance;
}
function verify(encoder) {
  asJsonEncoder(encoder);
}
function asJsonDecoder(_this__u8e3s4) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder()) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('This serializer can be used only with Json format.' + ('Expected Decoder to be JsonDecoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function verify_0(decoder) {
  asJsonDecoder(decoder);
}
function asJsonEncoder(_this__u8e3s4) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder()) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function _get_original__l7ku1m($this) {
  var tmp0 = $this.original$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('original', 1, tmp, defer$o$_get_original_$ref_3cje7k(), null);
  return tmp0.get_value_j01efc_k$();
}
function defer$o$_get_original_$ref_3cje7k() {
  return constructCallableReference((p0) => _get_original__l7ku1m(p0), 1, 0, 42);
}
var defer$1Class;
function defer$1() {
  if (defer$1Class === VOID) {
    class $ {
      constructor($deferred) {
        this.original$delegate_1 = lazy($deferred);
      }
      get_serialName_u2rqhk_k$() {
        return _get_original__l7ku1m(this).get_serialName_u2rqhk_k$();
      }
      get_kind_wop7ml_k$() {
        return _get_original__l7ku1m(this).get_kind_wop7ml_k$();
      }
      get_elementsCount_288r0x_k$() {
        return _get_original__l7ku1m(this).get_elementsCount_288r0x_k$();
      }
      getElementName_u4sqmf_k$(index) {
        return _get_original__l7ku1m(this).getElementName_u4sqmf_k$(index);
      }
      getElementIndex_utfbym_k$(name) {
        return _get_original__l7ku1m(this).getElementIndex_utfbym_k$(name);
      }
      getElementAnnotations_omrjs6_k$(index) {
        return _get_original__l7ku1m(this).getElementAnnotations_omrjs6_k$(index);
      }
      getElementDescriptor_ncda77_k$(index) {
        return _get_original__l7ku1m(this).getElementDescriptor_ncda77_k$(index);
      }
      isElementOptional_heqq56_k$(index) {
        return _get_original__l7ku1m(this).isElementOptional_heqq56_k$(index);
      }
    }
    protoOf($).get_isNullable_67sy7o_k$ = get_isNullable;
    protoOf($).get_isInline_usk17w_k$ = get_isInline;
    protoOf($).get_annotations_20dirp_k$ = get_annotations;
    initMetadataForClass($, VOID, VOID, VOID, [SerialDescriptor()]);
    defer$1Class = $;
  }
  return defer$1Class;
}
//region block: exports
export {
  JsonArraySerializer_getInstance as JsonArraySerializer_getInstance2u75x9rgsas6i,
  JsonElementSerializer_getInstance as JsonElementSerializer_getInstanceqpm5aw7w4cej,
  JsonNullSerializer_getInstance as JsonNullSerializer_getInstancejguwsicwxpex,
  JsonObjectSerializer_getInstance as JsonObjectSerializer_getInstance15ehqyi55oo4q,
  JsonPrimitiveSerializer_getInstance as JsonPrimitiveSerializer_getInstance7mj253uvdtw6,
};
//endregion

//# sourceMappingURL=JsonElementSerializers.mjs.map
